import { useTranslation } from "react-i18next";

import { Button, Card, Col, Divider, Flex, Row, Space, Spin } from "antd";
import { Info } from "components/elements";
import { useSelector } from "react-redux";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import styles from "../styles/EmployeeForm.module.css";
import EmployeeInfoContactForm from "./EmployeeInfoContactForm";

function EmployeeInfoContactInfo({
  isEditing = false,
  contactInfo = {},
  initialValues = {},
  relationshipOptions = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  handleProviceChange = () => { },
  handleDistrictChange = () => { },
  registeredProvinceOptionsTh = [],
  registeredProvinceOptionsEn = [],
  registeredDistrictOptionsTh = [],
  registeredDistrictOptionsEn = [],
  registeredSubDistrictOptionsTh = [],
  registeredSubDistrictOptionsEn = [],
  handleRegisteredProviceChange = () => { },
  handleRegisteredDistrictChange = () => { },
  isLoading = false,
  onEdit = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  isVisible = false,
  setIsVisible = () => { },
  handleToggleVisibility = () => { },
  permissions
}) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  const checkDisableVisible = () => {
    return roles?.includes("ACCESS_DATA_SECURITY|EMPLOYEE|CONTACT_INFO") ? false : true
  }
  const checkDisableEdit = () => {
    console.log("permissions", permissions);

    return permissions?.UPDATE ? true : true
  }

  if (isEditing) {
    return (
      <EmployeeInfoContactForm
        initialValues={initialValues}
        relationshipOptions={relationshipOptions}
        provinceOptionsTh={provinceOptionsTh}
        provinceOptionsEn={provinceOptionsEn}
        districtOptionsTh={districtOptionsTh}
        districtOptionsEn={districtOptionsEn}
        subDistrictOptionsTh={subDistrictOptionsTh}
        subDistrictOptionsEn={subDistrictOptionsEn}
        handleProviceChange={handleProviceChange}
        handleDistrictChange={handleDistrictChange}
        registeredProvinceOptionsTh={registeredProvinceOptionsTh}
        registeredProvinceOptionsEn={registeredProvinceOptionsEn}
        registeredDistrictOptionsTh={registeredDistrictOptionsTh}
        registeredDistrictOptionsEn={registeredDistrictOptionsEn}
        registeredSubDistrictOptionsTh={registeredSubDistrictOptionsTh}
        registeredSubDistrictOptionsEn={registeredSubDistrictOptionsEn}
        handleRegisteredProviceChange={handleRegisteredProviceChange}
        handleRegisteredDistrictChange={handleRegisteredDistrictChange}
        onSubmit={onSubmit}
        onCancel={onCancel}
        isLoading={isLoading}
      />
    );
  }
  return (
    <Spin spinning={isLoading}>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <Space style={{ width: "100%" }} size={16} direction="vertical" >
          {(roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|CONTACT_INFO") || roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|CONTACT_INFO")) &&
            (<Row style={{ gap: "10px" }} justify="end" >
              {roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|CONTACT_INFO") &&
                <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                  icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                  onClick={handleToggleVisibility}
                // disabled={checkDisableVisible()}
                />
              }
              {roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|CONTACT_INFO") &&
                <Button onClick={onEdit} type="primary"
                  style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: !isVisible ? null : "white" }}
                // disabled={!isVisible}
                >
                  <Flex align="center" justify="center" gap={8}>
                    <EditIcon />
                    {t("common.edit").toUpperCase()}
                  </Flex>
                </Button>}
            </Row>)
          }

          <Flex vertical style={{ rowGap: "16px" }}>
            <span style={{ fontSize: "16px" }}>{t('contact-information')}</span>

            <Row gutter={[0, 16]}>
              <Col span={8}>
                <Info
                  label={t('company-e-mail-username')}
                  value={contactInfo.email || "-"}
                />
              </Col>
              <Col span={8}>
                <Info
                  label={t('employee.telephone-no')}
                  value={contactInfo.telephoneNumber || "-"}
                />
              </Col>
              <Col span={8}>
                <Info
                  label={t('employee.personal-email-address')}
                  value={contactInfo.personalEmail || "-"}
                />
              </Col>
              <Col span={8}>
                <Info label={t('employee.mobile-no')} value={contactInfo?.mobileNumber || "-"} />
              </Col>
              <Col span={8}>
                <Info label={t('employee.line-id')} value={contactInfo.lineId || "-"} />
              </Col>
            </Row>
          </Flex>

          <Divider className={styles.customDivider} />

          <Flex vertical style={{ rowGap: "16px" }}>
            <span style={{ fontSize: "16px" }}>{t('register-address-information')}</span>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <Info
                  label={t('employee.address-th')}
                  value={contactInfo?.registerAddress ? contactInfo.fullRegisterAddress : "-"}
                />
              </Col>
              <Col span={24}>
                <Info
                  label={t('employee.address-en')}
                  value={contactInfo?.registerAddressEn ? contactInfo.fullRegisterAddressEn : "-"}
                />
              </Col>
            </Row>
          </Flex>

          <Divider className={styles.customDivider} />

          <Flex vertical style={{ rowGap: "16px" }}>
            <span style={{ fontSize: "16px" }}>{t('address-information')}</span>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <Info label={t('employee.address-th')} value={contactInfo?.address ? contactInfo.fullAddress : "-"} />
              </Col>
              <Col span={24}>
                <Info label={t('employee.address-en')} value={contactInfo?.addressEn ? contactInfo.fullAddressEn : "-"} />
              </Col>
            </Row>
          </Flex>

          <Divider className={styles.customDivider} />

          <Flex vertical style={{ rowGap: "16px" }}>
            <span style={{ fontSize: "16px" }}>{t('emergency-contacts')}</span>
            <Row gutter={[0, 16]}>
              <Col span={12}>
                <Info label={t('employee.name')} value={contactInfo.emergencyName || "-"} />
              </Col>
              <Col span={12}>
                <Info label={t('employee.surname')} value={contactInfo.emergencysurName || "-"} />
              </Col>
              <Col span={12}>
                <Info
                  label={t('employee.relationship')}
                  value={contactInfo?.relationship?.name || "-"}
                />
              </Col>
              <Col span={12}>
                <Info
                  label={t('employee.mobile-no')}
                  value={contactInfo.emergencyMobileNumber || "-"}
                />
              </Col>
            </Row>
          </Flex>
        </Space>
      </Card>
    </Spin>
  );
}

export default EmployeeInfoContactInfo;
